/**
 * Chinese (Simplified) display text for the Parent Portal shell.
 *
 * Key = the exact English source string in code. Keep `{name}` placeholders
 * identical in both languages. Product names (Hangar, HSC, Airbotix) stay in
 * English. Course content is English-only and never goes in this catalogue
 * (rules/course-content-english-only.md).
 */
export const ZH_SHELL: Readonly<Record<string, string>> = {
  'Parent Portal': '家长中心',
  'Airbotix home': 'Airbotix 首页',
  'Go to Parent Portal Home': '返回家长中心首页',
  'Back to {label}': '返回{label}',
  'Up to {label}': '返回上级：{label}',
  '{count} notifications need attention': '{count} 条通知待处理',
  'Sign out': '退出登录',
  'Signed in as': '当前登录',
  'Privacy choices': '隐私选项',
  Language: '语言',
  'Display language': '显示语言',
  'Switch to Chinese': '切换为中文',
  'Switch to English': '切换为英文',
  'This device shows the Portal in this language.': '本设备将以此语言显示家长中心。',
  Explore: '探索',
  Notifications: '通知',
  More: '更多',
  Family: '家庭',
  Account: '账户',
  'Create and plan': '创作与规划',
  'Account and support': '账户与支持',
  'More parent tools': '更多家长工具',
  Dashboard: '首页',
  Home: '首页',
  'Physics Lab': '物理实验室',
  'Virtual Chemistry Lab': '虚拟化学实验室',
  Courses: '课程',
  'School learning': '学校学习',
  'Verified school and tutor learning, reports and notices': '经核实的学校与导师学习、报告和通知',
  'Student Work': '学生作品',
  Tutoring: '私教辅导',
  'Online Courses': '在线课程',
  Online: '在线',
  'Exam Prep': '备考',
  'Family Guides': '家庭指南',
  Guides: '指南',
  'School compare': '学校对比',
  'Creative Code Challenge': '创意编程挑战赛',
  Challenge: '挑战赛',
  'Parent courses': '家长课程',
  'My Projects': '我的项目',
  Projects: '项目',
  'HSC Planner': 'HSC 规划',
  'My Study Plan': '我的学习计划',
  Usage: '使用情况',
  'Hangar computers': 'Hangar 电脑',
  Hangar: 'Hangar',
  'Rewards & credit': '奖励与抵扣',
  'Membership & Stars': '会员与星星',
  Wallet: '钱包',
  Billing: '账单',
  Settings: '设置',
  'Stars & usage': '星星与使用情况',
  'Billing & payments': '账单与付款',
  'Contact support': '联系客服',
  '{label}, opens in a new tab': '{label}（在新标签页打开）',
  'Top up Stars': '充值星星',
  'Choose a Stars pack.': '选择星星套餐。',
  'Star usage': '星星使用情况',
  'See usage by kid and task.': '按孩子和任务查看使用情况。',
  'Wallet and limits': '钱包与限额',
  'View activity and set spending limits.': '查看记录并设置消费限额。',
  'Auto top-up': '自动充值',
  'Set a low-balance refill.': '设置余额不足时自动充值。',
  'Stars & usage menu': '星星与使用情况菜单',
  'Close Stars menu': '关闭星星菜单',
  'Dismiss Stars menu': '关闭星星菜单',
  'Available now': '当前可用',
  'Loading…': '加载中…',
  '{balance} Stars': '{balance} 颗星星',
  'Like petrol for a car, Stars are prepaid fuel for the AI tools your child uses.':
    '星星就像汽车的汽油，是孩子使用 AI 工具的预付燃料。',
  'How Stars and AI tokens work': '星星和 AI token 如何计算',
  'Set up your family to use Stars.': '设置家庭后即可使用星星。',
  'Start family setup': '开始设置家庭',
  'Balance is unavailable.': '暂时无法获取余额。',
  'Try again': '重试',
  'Stars and usage actions': '星星与使用情况操作',
  'Stars balance loading': '星星余额加载中',
  'Stars balance unavailable': '星星余额暂不可用',
  'Stars unavailable until family setup': '设置家庭后才可使用星星',
  '{balance}. Open Stars menu': '{balance}。打开星星菜单',
  Checkout: '结账',
  'Course details': '课程详情',
  'Tutor profile': '导师资料',
  'Exam details': '考试详情',
  'Exam checkout': '考试结账',
  'Exam order': '考试订单',
  'Exam report': '考试报告',
  Register: '报名',
  Report: '报告',
  'Code challenge': '编程挑战赛',
  'How Stars work': '星星如何使用',
  'Add a kid': '添加孩子',
  'Kid projects': '孩子的项目',
  Passport: '创作护照',
  'Kid pictures': '孩子的图片',
  'Kid settings': '孩子设置',
  Activities: '活动记录',
  'Project activity': '项目动态',
  'Set up your family': '设置你的家庭',
  'Start setup →': '开始设置 →',
  'Study · learning records & Tutor method': '学习 · 学习记录与导师方法',
};
